import React from "react";

interface RunAllTestsButtonProps {
  isRunning: boolean;
  onClick: () => void;
}

export const RunAllTestsButton: React.FC<RunAllTestsButtonProps> = ({
  isRunning,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={isRunning}
      style={{
        color: "#fff",
        backgroundColor: isRunning ? "#ccc" : "#007bff",
        cursor: isRunning ? "not-allowed" : "pointer",
      }}
    >
      {isRunning ? "Running Tests..." : "Run All Tests"}
    </button>
  );
};

interface OnboardButtonProps {
  mnemonic: string;
  baseURL: string;
  onboardLoading: boolean;
  isRunning: boolean;
  onOnboard: (mnemonic: string, baseURL: string) => void;
}

export const OnboardButton: React.FC<OnboardButtonProps> = ({
  mnemonic,
  baseURL,
  onboardLoading,
  isRunning,
  onOnboard,
}) => {
  const isDisabled =
    onboardLoading || isRunning || !mnemonic || mnemonic.trim() === "";

  return (
    <button
      onClick={() => {
        if (mnemonic && mnemonic.trim() !== "") {
          onOnboard(mnemonic, baseURL);
        }
      }}
      disabled={isDisabled}
      style={{
        color: isDisabled ? "#ccc" : "#fff",
        backgroundColor: isDisabled ? "#ccc" : "#28a745",
        cursor: isDisabled ? "not-allowed" : "pointer",
      }}
    >
      {onboardLoading ? "Onboarding..." : "Onboard & Get Auth Token"}
    </button>
  );
};

interface ClearResultsButtonProps {
  isRunning: boolean;
  onClick: () => void;
}

export const ClearResultsButton: React.FC<ClearResultsButtonProps> = ({
  isRunning,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={isRunning}
      style={{
        color: isRunning ? "#ccc" : "#fff",
        backgroundColor: isRunning ? "#ccc" : "#dc3545",
        cursor: isRunning ? "not-allowed" : "pointer",
      }}
    >
      Clear Results
    </button>
  );
};

interface DismissErrorButtonProps {
  onClick: () => void;
}

export const DismissErrorButton: React.FC<DismissErrorButtonProps> = ({
  onClick,
}) => {
  return (
    <button onClick={onClick} className="sdk-test-button-dismiss">
      Dismiss
    </button>
  );
};
